<template>
  <b-modal
    v-model="innerValue"
    title="Terms & Conditions"
    body-class="px-4 pb-4 pt-0"
    size="lg"
    hide-footer
    @shown="addTermlyScript"
  >
  <div name="termly-embed" data-id="beb56943-acef-4d52-a264-4f6dc3cb4590" data-type="iframe"></div>
  </b-modal>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  name: "ModalTermsAndConditions",
  emits: ["input"],
  props: {
    value: Boolean,
  },
  setup(props, { emit }) {
    const innerValue = computed({
      get: () => props.value,
      set: (newValue) => emit("input", newValue),
    });

    const addTermlyScript = () => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "termly-jssdk";
      script.src = "https://app.termly.io/embed-policy.min.js";

      const head = document.getElementsByTagName("head")[0];
      head.appendChild(script);
    };

    return {
      innerValue,
      addTermlyScript,
    };
  },
});
</script>
